/* eslint arrow-body-style: 0 */
import SettingsContent from '../Wrapper';
import Settings from './Settings';
import InboxHome from './Index';
import InboxChannel from './InboxChannels';
import ChannelList from './ChannelList';
import channelFactory from './channel-factory';
import AddAgents from './AddAgents';
import FinishSetup from './FinishSetup';
import whatsappConnectGuard, {
  INBOX_CHANNEL_FORM_ROUTE,
  WHATSAPP_CHANNEL_NAME,
  WHATSAPP_CONNECT_ROUTE,
} from './helpers/whatsappConnectGuard';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_inbox_list';
        return {
          headerTitle: 'INBOX_MGMT.HEADER',
          headerButtonText: 'SETTINGS.INBOXES.NEW_INBOX',
          icon: 'mail-inbox-all',
          newButtonRoutes: ['settings_inbox_list'],
          showBackButton,
        };
      },
      children: [
        {
          path: '',
          name: 'settings_inbox',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          roles: ['administrator'],
        },
        {
          path: 'new',
          component: InboxChannel,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              component: ChannelList,
              roles: ['administrator'],
            },
            {
              path: ':sub_page',
              name: 'settings_inbox_conditions',
              component: channelFactory.create(),
              roles: ['administrator'],
              props: route => {
                return { channel_name: route.params.sub_page, step: 1 };
              },
            },
            {
              path: ':sub_page',
              name: 'settings_inbox_add_name_and_number',
              component: channelFactory.create(),
              roles: ['administrator'],
              props: route => {
                return { channel_name: route.params.sub_page, step: 2 };
              },
            },

            {
              path: ':sub_page',
              name: 'settings_inbox_link_number',
              component: channelFactory.create(),
              roles: ['administrator'],
              props: route => {
                return { channel_name: route.params.sub_page, step: 3 };
              },
            },
            // Paso 2 del alta de WhatsApp Cloud: conexión asistida o manual según ?path=.
            // Path propio (no ':sub_page') para que URL directa, recarga e historial resuelvan
            // siempre a esta ruta; el guard regresa al selector si falta el camino.
            {
              path: `${WHATSAPP_CHANNEL_NAME}/connect`,
              name: WHATSAPP_CONNECT_ROUTE,
              component: channelFactory.create(),
              roles: ['administrator'],
              beforeEnter: whatsappConnectGuard,
              props: () => ({ channel_name: WHATSAPP_CHANNEL_NAME, step: 2 }),
            },
            {
              path: ':sub_page',
              name: INBOX_CHANNEL_FORM_ROUTE,
              component: channelFactory.create(),
              roles: ['administrator'],
              props: route => {
                return { channel_name: route.params.sub_page };
              },
            },
            {
              path: ':inbox_id/agents',
              name: 'settings_inboxes_add_agents',
              roles: ['administrator'],
              component: AddAgents,
            },
            {
              path: ':inbox_id/finish',
              name: 'settings_inbox_finish',
              component: FinishSetup,
              roles: ['administrator'],
            },
          ],
        },
        {
          path: ':inboxId',
          name: 'settings_inbox_show',
          component: Settings,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
